import React, { Component } from 'react'
import { Grid, List, Button, Divider, Input, Label } from 'semantic-ui-react'
import ReactAudioPlayer from 'react-audio-player'
import Zoom from 'react-simple-zoom'
import ModalVerify from './ModalVerify'
import { API_SEARCH_NIK } from '../../api'

export default class AccordionListContent extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: {},
      modalOpen: false,
      statusReject: [],
      statusApprove: null,
      imageKTP: null,
      msgNik: null
    }
  }

  initialData = (props) => {
    this.setState({
      data: props.propsData,
      statusReject: props.propsData.failureReason,
      statusApprove: props.propsData.status,
      imageKTP: props.propsKTP,
      msgNik: null
    })
  }

  componentDidMount() {
    this.initialData(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.initialData(nextProps)
  }

  setGroupImageAndVoice = (data) => {
    const { imageKTP } = this.state
    const configFieldType = {
      'ktp_selfie_url': 'image',
      'ktp_url': 'image',
      'selfie_url': 'image',
      'signature_url': 'signature_url',
      'voice_url': 'audio',
      'ktp_nik': 'input',
      'dob': 'needKtp',
      'pob': 'needKtp',
      'ktp_address': 'needKtp',
      'full_name': 'needKtp'
    }

    if (!data.fieldValue) {
      return <p>Data kosong</p>
    }

    switch (configFieldType[data.fieldCode]) {
    case 'image':
      return (
        <div>
          <h4>{data.fieldName}</h4>
          <Zoom thumbUrl={data.fieldValue} fullUrl={data.fieldValue} zoomScale={1} />
        </div>
      )
    case 'signature_url':
      return (
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={9} >
                  <h4>{data.fieldName}</h4>
                  <Zoom thumbUrl={data.fieldValue} fullUrl={data.fieldValue} zoomScale={2} />
                </Grid.Column>
                <Grid.Column width={7} >
                  <h4>Foto KTP</h4>
                  <Zoom thumbUrl={imageKTP} fullUrl={imageKTP} zoomScale={4} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            )
    case 'audio':
      return (
        <div>
          <h4>{data.fieldName}</h4>
          <ReactAudioPlayer src={data.fieldValue} controls />
          <p><strong>{data.metadata.text || data.metadata.b}</strong></p>
        </div>
      )
    case 'input':
      return (
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={11} >
              <h4>Photo KTP</h4>
              <Zoom thumbUrl={imageKTP} fullUrl={imageKTP} zoomScale={1.5} />
            </Grid.Column>
            <Grid.Column width={5} >
              <h4>{data.fieldName}</h4>
              <Input value={data.fieldValue} disabled fluid/>
              <br/>
              <Button fluid color='teal' content='Check Duplicate' onClick={(e) => this.handleCheckNIK(e, data.fieldValue)}/>
              <p style={{ textAlign: 'center', paddingTop: '5px'}}>{this.state.msgNik}</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )
    case 'needKtp':
      return (
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={9}>
              <h4>Foto KTP</h4>
              <Zoom thumbUrl={imageKTP} fullUrl={imageKTP} zoomScale={4}/>
            </Grid.Column>
            <Grid.Column width={7}>
              <h4>{data.fieldName}</h4>
              <p>{data.fieldValue}</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )
    default:
      return (
        <div>
          <h4>{data.fieldName}</h4>
          <Input type='text' disabled={true} value={data.fieldValue}/>
        </div>
      )
    }
  }

  /* =========================================
  :: Handle Function
  ==========================================*/

  handleChangeStatusApprove = (e, value) => {
    e.preventDefault()
    if(value !==  this.state.statusApprove) {
      this.setState({
        statusApprove: value,
        statusReject: '',
      })
      this.props.propsStatusApprove(this.props.propsKey, value)
    }
  }

  handleChangeStatusReject = (value) => {
    if(value !== '' && value !==  this.state.statusReject) {
      this.setState({
        statusApprove: '',
        statusReject: value
      })
      this.props.propsStatusReject(this.props.propsKey, value)
    }
  }

  handleModalOpen = () => this.setState({ modalOpen: true })

  handleModalClose = () => this.setState({ modalOpen: false })

  handleCheckNIK = (e, value) => {
    e.preventDefault()
    API_SEARCH_NIK(value)
      .then((response) => {
        let data = response.data.count
        if(data > 1){
          this.setState({msgNik: 'Sudah Terdaftar'})
        }else{
          this.setState({msgNik: 'Benar'})
        }
      })
      .catch((error) => {
        this.setState({msgNik: error})
      })
  }

  render() {
    const { data, statusApprove, statusReject } = this.state

    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={9} >
            {this.setGroupImageAndVoice(data)}
          </Grid.Column>
          <Grid.Column width={7} >
            <h4>Ketentuan</h4>

            <List as='ol'>
              {
                data.fieldRequirements ?
                 data.fieldRequirements.map( (list, i) => {
                    return ( <List.Item as='li' key={i}>{list}</List.Item> )
                  })
                : null
              }
            </List>
            <Divider section />

            {
              statusReject ?
                <div>
                  <Label as='a' color='red' tag>{statusReject}</Label>
                  <Divider section />
                </div>
              : null
            }

            {
              statusApprove !== 'pending' && statusApprove !== 'failed' && statusApprove !== 'new' ?
                <div>
                  <Label as='a' color='green' tag>{statusApprove}</Label>
                  <Divider section />
                </div>
              : null
            }

            <Button
              primary
              floated='left'
              onClick={(e) => this.handleChangeStatusApprove(e, data.fieldName)}>Benar</Button>

            <ModalVerify
              trigger={<Button onClick={this.handleModalOpen} negative floated='right'>Salah</Button>}
              open={this.state.modalOpen}
              onClose={this.handleModalClose}
              reasonValue={statusReject}
              reasonsData={data.failureOptions}
              reasonChangeValue={this.handleChangeStatusReject}
            />

          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/component/Verification/AccordionListContent.js